import React from 'react';

import {CardOverflow, CircularProgress} from "@mui/joy";
import CardContent from "@mui/joy/CardContent";
import Card from "@mui/joy/Card";

// components
import TaskCardInner from "../Task/TaskCardInner";
import TaskDetail from "../Task/TaskDetail";
import Typography from "@mui/joy/Typography";


class TaskCard extends React.Component {
    render() {
        if (!this.props.task) {
            return (<CircularProgress/>)
        }
        return (
            <Card
                size={'sm'}
                orientation="horizontal"
            >
                <CardOverflow
                    variant='soft'
                    color={this.props.task.work_status_color}
                    sx={{
                        px: 0.2,
                        borderLeft: '1px solid',
                        borderColor: 'divider',
                    }}
                >
                    <Typography
                        sx={{
                            writingMode: 'vertical-lr',
                            transform: 'rotate(180deg)',
                            textAlign: 'right',
                            fontSize: 'xs',
                            fontWeight: 'xl',
                            letterSpacing: '1px',
                            textTransform: 'uppercase',
                        }}
                    >
                        {this.props.task.work_status_human}
                    </Typography>
                </CardOverflow>
                <CardContent
                    sx={{
                        overflow: 'auto',
                    }}
                >
                    <TaskCardInner
                        task={this.props.task}
                        hidePhase={this.props.hidePhase}
                        hideOpportunity={this.props.hideOpportunity}
                        callBack={this.props.callBack}
                    />
                </CardContent>
                <CardOverflow
                    variant='soft'
                    sx={{
                        px: 0.2,
                        alignContent: 'center'
                    }}
                >
                    <TaskDetail
                        taskId={this.props.task.id}
                        ref={this.taskDetails}
                        callBack={this.props.callBack}
                    />
                </CardOverflow>
            </Card>
        )
    }
}


export default TaskCard;
